import layout from '@/layout'

export default {
  path: '/config',
  component: layout,
  redirect: '/config/join_owner',
  name: 'config',
  meta: {
    title: '配置',
    icon: 'config'
  },
  children: [
    // 老板
    {
      path: '/config/join_owner',
      name: 'join_owner',
      component: () => import('@/views/config/join_owner/index'),
      meta: {
        title: '老板',
        icon: 'config'
      }
    },
    // 门店
    {
      path: '/config/verson1_bank',
      name: 'config_verson1_bank',
      component: () => import('@/views/config/verson1_bank/index'),
      meta: {
        title: '门店',
        icon: 'config'
      }
    },
    // 品牌
    {
      path: '/config/goods_brand',
      name: 'config_goods_brand',
      component: () => import('@/views/config/goods_brand/index'),
      meta: {
        title: '品牌',
        icon: 'config'
      }
    },
    // 外卖平台
    {
      path: '/config/takeout_platform',
      name: 'config_takeout_platform',
      component: () => import('@/views/config/takeout_platform/index'),
      meta: {
        title: '外卖平台',
        icon: 'config'
      }
    },

    // 售卖渠道
    // {
    //   path: '/config/channel',
    //   name: 'config_channel',
    //   component: () => import('@/views/config/channel/index'),
    //   meta: {
    //     title: '售卖渠道',
    //     icon: 'config'
    //   }
    // },
    // 单位
    {
      path: '/config/unit',
      name: 'config_unit',
      component: () => import('@/views/config/unit/index'),
      meta: {
        title: '单位',
        icon: 'config'
      }
    },
    // 系统配置
    {
      path: '/config/system',
      name: 'config_system',
      component: () => import('@/views/config/system/index'),
      meta: {
        title: '系统配置',
        icon: 'config'
      }
    }
  ]
}
